import { PaymentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DeleteBankingPaymentDocument,
  PaymentsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useRemoveBulkPayment = () => {
  const [deleteBankingPayment, { loading }] = useMutation(DeleteBankingPaymentDocument, {
    extractorFn: (data) => data.bankingMutations.deleteBankingPayment,
    refetchQueries: [PaymentsDataTableDocument, PaymentsDataCollectionDocument],
    awaitRefetchQueries: true,
  })

  const submitRemoveBulkPayment = async ({ paymentId }: { paymentId: number }) => {
    const result = await deleteBankingPayment({
      variables: {
        paymentId: paymentId,
      },
    })
    const handled = handleResult(result, () => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.bulk_payment.deleted_bulk_payment'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
    return handled
  }

  return {
    submitRemoveBulkPayment,
    loading,
  }
}
